import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const BatchPoDetails = lazy(() => import('components/batchPO/BatchPoDetails'));
const ProductOrderDetails = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<BatchPoDetails />
			</Suspense>
		</div>
	);
};
export default ProductOrderDetails;
